import { activeSiteConfig } from "@config/site/site-config";
import { useGetHeaders } from "@hooks/useGetHeaders";
import { CommonCMS, commonReplacements } from "@lib/constants/contentful";
import { Footer } from "@lib/constants/contentful/footer";
import { useSubmit } from "./useSubmit";
import { useMicrocopy } from "@lib/contentful/microcopy/MicrocopyContext";

export const useFooter = () => {
    const { reCaptchaIntegration } = activeSiteConfig;
    const { get: getMicrocopy } = useMicrocopy();

    const maxNameCharacters = getMicrocopy(CommonCMS.shared, CommonCMS.error.maxCharacters, {
        replacements: commonReplacements.maxNameCharacters,
    });

    const headers = useGetHeaders({
        source: CommonCMS.shared,

        microcopiesWithTitles: {
            header: Footer.newsletter.header,
            checkboxText: Footer.newsletter.checkboxText,
            headerSuccess: Footer.newsletter.success,
            emailLabel: Footer.newsletter.emailLabel,
            nameLabel: Footer.newsletter.nameLabel,
            discountDisclaimer: Footer.newsletter.discountDisclaimer,
            description: Footer.newsletter.description,
            descriptionSuccess: Footer.newsletter.successDescription,
            emailInputPlaceholder: Footer.newsletter.emailInputPlaceholder,
            email: CommonCMS.email,
            subscribeButton: CommonCMS.subscribeButton,
            emailError: CommonCMS.error.email,
            requiredFieldError: CommonCMS.error.requiredFieldError,
            policy: CommonCMS.error.requiredFieldError,
            titleError: CommonCMS.error.general.title,
            descriptionError: CommonCMS.error.general.description,
            maxCharacters: CommonCMS.error.maxCharacters,
            requiredLabel: CommonCMS.requiredLabel,
            requiredField: CommonCMS.requiredLabel,
        },
        options: { replacements: commonReplacements.maxEmailCharacters },
    });

    const { isPending, isSuccess, onSubmit } = useSubmit({
        reCaptchaIntegration,
        error: {
            description: headers.descriptionError,
            title: headers.titleError,
        },
    });

    return {
        isPending,
        isSuccess,
        onSubmit,
        headers: { ...headers, maxNameCharacters },
    };
};
